module.exports = __webpack_public_path__ + "media/images/procedure_managements/how_to_create/img_1-6609e444879f1e3d47c17d6e942bb299.png";